var render = function render(){var _vm=this,_c=_vm._self._c;return _c('streaming-line-chart',{ref:"statsCountChart",attrs:{"height":300,"chart-data":_vm.chartData,"dataset":_vm.dataset,"is-started":_vm.isStarted,"options":_vm.chartOption,"time-scale":_vm.scala}})
}
var staticRenderFns = []

export { render, staticRenderFns }